import { render, staticRenderFns } from "./NetworkCard.vue?vue&type=template&id=22c8e3b1&scoped=true&"
import script from "./NetworkCard.vue?vue&type=script&lang=js&"
export * from "./NetworkCard.vue?vue&type=script&lang=js&"
import style0 from "./NetworkCard.vue?vue&type=style&index=0&id=22c8e3b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c8e3b1",
  null
  
)

export default component.exports